<template>
  <article>
    <h2 v-if="title" class="text-lg font-bold leading-none uppercase md:text-xl lg:text-2xl mb-4 md:mb-6">{{ title }}</h2>
    <ul class="-mx-6 sm:-mx-8 md:mx-0 lg:-mx-6 border-b-2 border-app-green-100">
      <li v-for="(item, index) in entries" :key="index">
        <MoleculeQuestionAndAnswer :question="item.question" :answer="item.answer" />
      </li>
    </ul>
  </article>
</template>

<script setup lang="ts">
interface Props {
  title?: string
  entries: Array<{ question: string; answer: string }> // Assuming the structure of entries
}

defineProps<Props>()
</script>
